
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fancy",
      function () {
        return require("private-next-pages/fancy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fancy"])
      });
    }
  